import "angular:locale/data:de";
import "@angular/localize/init";(globalThis.$localize ??= {}).locale = "de";
